import React, { FC } from 'react';
import { Container } from '@goldbely/explore-component-library';

import { LazyImgix } from 'src/explore/elements/LazyImgix';

import styles from './index.module.sass';

interface BannerProps {
  alt: string;
  src?: string;
}

const Banner: FC<BannerProps> = ({ alt, src }) =>
  src ? (
    <Container className={styles.container} unpadded>
      <LazyImgix
        alt={alt}
        className={styles.image}
        height={300}
        sizes="100vw"
        src={src}
        width={1500}
      />
    </Container>
  ) : null;

export default Banner;
